<template>
	<div style="max-width: 960px; padding:12px;">
		<v-form>
			<v-card class="mb-4">
				<v-toolbar v-if="hrDocument.id == null" card prominent>
					<v-toolbar-title class="subheading">New Policy</v-toolbar-title>
					<v-spacer></v-spacer>
				</v-toolbar>

				<v-card-text class="text-xs-left">
					<v-text-field v-model="form.name" :error-messages="nameErrors" label="Policy Name" required @input="$v.form.name.$touch()" @blur="$v.form.name.$touch()"></v-text-field>

					<textarea id="sun-editor" ref="sunEditor"></textarea>
				</v-card-text>
			</v-card>

			<create-new-version-confirmation-dialog :dialog="showConfirmDialog" :isConfirming="isSaving" @onConfirm="submit" @onCancel="showConfirmDialog = false" />

			<v-footer color app height="55">
				<v-spacer></v-spacer>
				<footer-back-btn @click="cancel" />

				<v-btn v-if="form.id && $_hasAccessToFeature($FeatureId.COMPANY_POLICIES_MANAGE, $PermissionAction.USE)" class="action-btn" @click="showConfirmDialog = true">
					Save
					<v-icon right>send</v-icon>
					<span slot="loader">Saving...</span>
				</v-btn>
				<v-btn v-else-if="$_hasAccessToFeature($FeatureId.COMPANY_POLICIES_MANAGE, $PermissionAction.USE)" class="action-btn" :loading="isSaving" :disabled="isSaving" @click="submit">
					Save
					<v-icon right>send</v-icon>
					<span slot="loader">Saving...</span>
				</v-btn>
			</v-footer>
		</v-form>
	</div>
</template>

<script>
	import { validationMixin } from 'vuelidate';
	import { required } from 'vuelidate/lib/validators';
	import CreateNewVersionConfirmationDialog from '@/components/hrDocuments/CreateNewVersionConfirmationDialog';
	import suneditor from 'suneditor';
	import plugins from 'suneditor/src/plugins';

	export default {
		props: {
			isAdmin: {
				type: Boolean,
				required: true
			},
			hrDocument: {
				type: Object,
				default: () => ({
					id: null,
					name: '',
					description: '',
					content: null,
					category: null
				})
			},
			isSaving: {
				required: false,
				default: false,
				type: Boolean
			}
		},
		components: {
			CreateNewVersionConfirmationDialog
		},
		data() {
			return {
				editor: null,
				form: {
					id: this.hrDocument.id,
					name: this.hrDocument.name,
					description: this.hrDocument.description,
					content: this.hrDocument.content
				},
				showConfirmDialog: false
			};
		},
		computed: {
			nameErrors() {
				const errors = [];
				if (!this.$v.form.name.$dirty) return errors;
				!this.$v.form.name.required && errors.push('Policy Name is required.');
				return errors;
			}
		},
		methods: {
			submit(incrementVersion) {
				this.$v.form.$touch();

				if (this.$v.form.$invalid) {
					console.log('invalid form');
				} else {
					let postObj = {
						id: this.form.id != undefined ? this.form.id : this.newGuid(),
						name: this.form.name,
						description: this.form.description,
						content: this.form.content,
						incrementVersion,
						category: this.hrDocument.category
					};

					this.$emit('save', postObj);
				}
			},
			cancel() {
				window.history.back();
			}
		},
		mixins: [validationMixin],
		validations: {
			form: {
				name: { required }
			}
		},
		mounted() {
			this.editor = suneditor.create('sun-editor', {
				placeholder: '',
				value: this.form.content,
				plugins: plugins,
				width: '100%',
				height: '100%',
				pasteTags: "table, tbody, thead, tfoot, tr, th, td, span, p, div",
				pasteRestrict: false,
				pasteBlockTags: "div p",
				pasteConvertWord: true,
				buttonList: [
					['undo', 'redo', 'fontSize', 'formatBlock'],
					['bold', 'underline', 'italic', 'strike', 'removeFormat'],
					['fontColor', 'hiliteColor'],
					['outdent', 'indent', 'align', 'horizontalRule', 'list'],
					['table', 'link', 'fullScreen']
				]
			});
			this.editor.onChange = () => {
				this.form.content = this.editor.getContents();
			};
		}
	};
</script>
